import './instrument';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import reportWebVitals from 'reportWebVitals';

import {
  ViewerProvider,
  ThemeProvider,
  AlertsProvider,
  i18next,
  ToastContainer,
  DropdownProvider,
  TooltipProvider,
} from 'dash-ui';

import { BreadcrumbProvider } from 'common/contexts/breadcrumb-context/breadcrumb-context';

import App from 'App';
import { client } from 'gql/client';

import 'react-toastify/dist/ReactToastify.min.css';
import './index.css';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <ThemeProvider>
          <I18nextProvider i18n={i18next}>
            <ViewerProvider>
              <BreadcrumbProvider>
                <AlertsProvider>
                  <DropdownProvider>
                    <TooltipProvider>
                      <>
                        <App />
                        <ToastContainer shiftTop={60} shiftRight={32} />
                      </>
                    </TooltipProvider>
                  </DropdownProvider>
                </AlertsProvider>
              </BreadcrumbProvider>
            </ViewerProvider>
          </I18nextProvider>
        </ThemeProvider>
      </ApolloProvider>
    </BrowserRouter>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
